import BaseService from './BaseService'
import config from './../config/index'

class WhatsAppService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  isConfigured = (locationId: string) => 
    this.requests.get(
      `/location/${locationId}/is-configured`
    )
  onboard = (data: {locationId: string, companyId: string, inputToken: string}) => 
    this.requests.post(
      '/onboard',
      data
    )
  resync = (data: {locationId: string}) =>
    this.requests.put(
      `/location/${data.locationId}/resync`,
      {}
    )
  getAccountInfo = (data: {locationId: string}) =>
    this.requests.get(
      `/location/${data.locationId}/account-info`,
      {}
    )
  getWhatsAppPhoneNumbersForLocationId = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/phone-numbers`
    )
  makeDefaultPhoneNumber = (locationId: string, phoneNumberId: string) =>
    this.requests.put(
      `/location/${locationId}/phone-numbers/${phoneNumberId}/default`,
      {}
    )
  getWhatsAppTemplatesForLocationId = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/template`
    )
  createWhatsAppTemplateForLocationId = (locationId: string, data: any) => 
    this.requests.post(
      `/location/${locationId}/template`, 
      data
    )
  updateWhatsAppTemplateForLocationId = (locationId: string, templateId: string, data: any) => 
    this.requests.post(
      `/location/${locationId}/template/${templateId}`, 
      data
    )
  deleteWhatsAppTemplateForLocationId = (locationId: string, templateId: string, templateName: string) =>
    this.requests.delete(
      `/location/${locationId}/template/${templateId}/${templateName}`, 
    )
  getProduct = () =>
    this.requests.get(
      '/reselling/product', 
    )
  getCompanyResellingConfiguration = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/reselling/configuration`
    )
  updateCompanyResellingConfiguration = (companyId: string, data: { amount: number }) =>
    this.requests.put(
      `/company/${companyId}/reselling/configuration`,
      data
    )
  getLocationResellingConfiguration = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/configuration`
    )
  updateLocationResellingConfiguration = (locationId: string, data: { amount?: number, offeringEnabled?: boolean }) =>
    this.requests.put(
      `/location/${locationId}/reselling/configuration`,
      data
    )
  getCompanySubscriptions = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/reselling/subscription`
    )
  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/subscription`
    )
  locationSub = (locationId: string) =>
    this.requests.post(
      `/location/${locationId}/reselling/subscription`,
      {}
    )
}

class WhatsAppSaasInstance extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  paymentMethods = (locationId: string) => 
    this.requests.get(
      `/location-payment-methods/${locationId}`
    )
  createCustomerIfNotExists = (locationId: string, data: any) =>
    this.requests.post(
      `/location-payment-methods/${locationId}/create_customer_if_not_exists`,
      data
    )
  setupStripeIntent = (locationId: string, data: any) =>
    this.requests.post(
      `/saas-config/${locationId}/setup-stripe-intent`,
      data
    )
  paymentMethodExists = (locationId: string, data: any) =>
    this.requests.post(
      `/location-payment-methods/${locationId}/payment-method-exists`,
      data
    )
  updateCard = (locationId: string, data: any) =>
    this.requests.post(
      `/location-payment-methods/${locationId}`,
      data
    )
}

export const whatsAppService = new WhatsAppService(config.ghlRevexBackendWhatsAppBaseUrl)

export const whatsAppSaasInstance = new WhatsAppSaasInstance(config.saasServiceBaseUrl)

export default {}